import { Component, OnInit } from '@angular/core';
import { OpsappService } from '../../services/opsapp.service';
import { ActivatedRoute, Router } from '@angular/router';
import { buffer, first } from 'rxjs';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-incident-detail',
  templateUrl: './incident-detail.component.html',
  styleUrls: ['./incident-detail.component.css']
})
export class IncidentDetailComponent implements OnInit {
  incident: any;
  newNoteModal: boolean = false;
  newAttachmentModal: boolean = false;
  notes: any;
  summary: string;
  file: File;
  fileContent: any;
  saveEnabled: boolean = true;
  submitWait: boolean = false;
  disableGoFMX: boolean = false;
  filePreviews: string[] = [];
  mappedFiles: any[] = [];

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){

  }

  ngOnInit(){
    this.loadData();
  }

  loadData(){
    this.opsappService.activeIncident.pipe(first()).subscribe(data => {
      if (data == undefined || data == null)
        this.goToIncidents();
      else
      {
        console.log(data);
        this.incident = data;
        this.notes = this.incident?.ticket?.messages.slice(1);
      }
    });
    // this.incident = {id: 2, instrumentId: "12345", instrumentName: "IsolationStation3", createdBy: "Brad", 
    // createdDate: Date.now(), title: "Shaker timeout", description: "Blah blah blah", 
    // icons: [{iconClass: "pi pi-circle-fill", iconColor: "text-blue-700"}, {iconClass: "pi pi-comment", iconColor: "text-yellow-400"}],
    // notes: [{userName: "Brad", createdDate: Date.now(), details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae sapien pellentesque habitant morbi tristique senectus et netus. Vitae proin sagittis nisl rhoncus mattis. Maecenas pharetra convallis posuere morbi leo urna molestie."}, 
    //   {userName: "Thane", createdDate: Date.now(), details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae sapien pellentesque habitant morbi tristique senectus et netus. Vitae proin sagittis nisl rhoncus mattis. Maecenas pharetra convallis posuere morbi leo urna molestie."}],
    // attachments: [{attachmentName: "imagedetails.png", createdDate: Date.now(), link: "https://google.com"}]};
  }

  goToIncidents(){
    this.router.navigate(["incidents"], { relativeTo: this.route.parent });
  }

  addImage(){
    this.newAttachmentModal = true;
  }

  addNote(){
    this.newNoteModal = true;
  }

  handleFileInput(e: Event){
    this.saveEnabled = false;
    var fileList = (e.target as HTMLInputElement).files;
    var files = Array.from(fileList!);
    var count = files.length;
    files.forEach(file => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var fileContent = reader.result!.toString();
        this.mappedFiles.push(
          {
            FileName: file.name,
            Content: fileContent.replace(/^data:image\/[a-z]+;base64,/, ""),
            ContentType: file.type
          }
        );
        this.filePreviews.push(URL.createObjectURL(file));
        if (!--count)
        {
          (e.target as HTMLInputElement).value = "";
          this.saveEnabled = true;
        }
      }
    });
  }

  saveNote(){
    this.submitWait = true;
    var incidentNote = {
      IncidentId: this.incident.incidentId,
      HfUserId: this.incident.ticket.user.id,
      Text: this.summary,
      UserName: "",
      StatusId: 0,
      Attachments: new Array
    }

    if (this.mappedFiles.length > 0)
    {
      incidentNote.Attachments = this.mappedFiles;
    }

    this.opsappService.addNoteToIncident(incidentNote).then(data => {
      this.messageService.add({severity:'success', summary:'Note added successfully!'});
      this.newNoteModal = false;
      this.submitWait = false;
      //this.clearNote();
      this.goToIncidents();
    }).catch(() => {
      this.messageService.add({severity:'error', summary:'Couldn\'t add the note to the incident.'});
    });
  }

  hasNotes(incident: any){
    return incident?.ticket?.messages.length > 1
  }

  hasAttachment(note: any){
    return note.attachments.length > 0;
  }

  hasAttachments(incident: any){
    const attachmentCount = (message:any) => message.attachments.length > 0;
    return incident?.ticket?.messages.some(attachmentCount);
  }

  setIncidentIconClass(status: string){
    if (status == "New")
      return "pi pi-circle-fill text-blue-700";
    else if (status =="Open")
      return "pi pi-circle text-blue-700";
    else if (status == "Pending")
      return "pi pi-question-circle text-purple-400";
    else if (status == "Resolved")
      return "pi pi-check-circle text-green-400";
    else if (status == "Note")
      return "pi pi-comment text-yellow-400";
    else if (status == "Attachment")
      return "pi pi-paperclip text-bluegray-400";
    else
      return "";
  }

  processLinks(e: any) {
    const element: HTMLElement = e.target;
    if (element.nodeName === 'A') {
      const link = element.getAttribute('href');
      const param = element.getAttribute('param');
      if (link != undefined && link != null)
      {
        if (!link.includes("gofmx"))
        {
          e.preventDefault();
          this.router.navigate([link, {barcode: param}], { relativeTo: this.route.parent });
        }
      }
    }
  }

  clearNote(){
    this.file = null;
  }

  closeNoteModal(){
    this.newNoteModal = false;
    this.summary = "";
    this.filePreviews = [];
    this.mappedFiles = [];
  }

  createGoFMX()
  {
    this.disableGoFMX = true;
    this.opsappService.createGoFMX(this.incident).then(data => {
      this.messageService.add({severity:'success', summary:'GoFMX ticket created successfully!'});
      this.disableGoFMX = false;
      this.goToIncidents();
    }).catch(() => {
      this.disableGoFMX = false;
      this.messageService.add({severity:'error', summary:'Couldn\'t create GoFMX ticket.'});
    });
  }
}
